var _style, _polygon, _polygon2, _path, _path2, _circle, _circle2, _circle3, _circle4, _path3, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _path4, _path5, _path6, _circle13, _circle14, _circle15, _path7, _path8, _circle16, _circle17, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle18, _path17, _path18, _path19, _path20, _path21, _rect;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLaunching(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 861.3 648.7",
    style: {
      enableBackground: "new 0 0 861.3 648.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A0616A;}\n\t.st1{fill:#99D022;}\n\t.st2{fill:#4D4F97;}\n\t.st3{fill:#FF6584;}\n\t.st4{fill:#F0F0F0;}\n\t.st5{fill:none;}\n\t.st6{fill:#E4E4E4;}\n\t.st7{opacity:0.3;fill:#F0F0F0;enable-background:new    ;}\n\t.st8{fill:#2F2E41;}\n\t.st9{fill:#F2F2F2;}\n\t.st10{fill:#3F3D56;}\n\t.st11{fill:#CACACA;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "68.6,616 84.8,620.3 109.1,559.6 85.1,553.3 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "152,628.2 168.8,628.2 176.8,563.3 152,563.3 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.9,317.8c-4.1,5.1-2,22.3-2,22.3s-7.1,55.9-4.1,60.9s-2,9.1-5.1,16.2s-6.1,24.4-6.1,24.4 c-17.3,14.2-16.2,79.2-16.2,79.2l-6.1,57.9c2,6.1,30.5,7.1,34.5,6.1s43.7-144.2,43.7-144.2s-2,138.1-2,144.2s27.4,3,33.5,3 s44.7-248.8,44.7-248.8v-14.2l-5.1-7.1C219.6,317.8,114,312.7,109.9,317.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M318.6,172.7c37.1-23.9,88.2-14.6,124.3,10.7c11.8,8.4,22.6,18.1,32.3,28.8c5.6,6.2,11,12.7,16.1,19.4 c1.3,1.6,2.5,3.3,3.7,5c0.8,1.1,1.7,2.3,2.5,3.4c10.4,14.4,19.9,29.6,29.2,44.6c23.3,37.5,47.1,76.2,82.5,102.5 c7.3,5.4,17.5,10.3,25,5.1c6.5-4.5,6.8-14,5.3-21.7c-5.5-28.7-25.3-52.6-46.3-72.9c-21-20.3-44.3-39-60.2-63.5 c-15.9-24.6-23.2-57.4-9.2-83.1c12-22.2,37.8-34.6,63-35.2c25.2-0.6,49.7,9.2,71,22.7c21.3,13.5,40.1,30.5,59.6,46.4 c11.8,9.6,28.3,19.1,41.1,11c10.9-6.9,11.7-23.3,5.2-34.4c-6.5-11.1-18-18.1-29.1-24.6c-34.4-20.2-68.7-40.4-103.1-60.6 c-10.5-6.2-21.3-12.6-29.1-22c-7.8-9.4-12.1-22.7-7.8-34.1C599,9,610.8,1.9,622.7,0.4c12-1.5,24,1.8,35.2,6.3 c41.9,16.8,140.6,127,166.9,145.8c16.9,12.1,34.7,27.4,36.4,48.1c2.1,25.8-23.5,47.2-49.3,49.7c-25.7,2.5-50.7-8.7-73.7-20.5 s-46.5-24.9-72.3-26.5c-25.8-1.6-54.8,12.2-60.9,37.3c-5.3,21.9,8.2,44.4,25.8,58.4c13.8,11,30,18.3,45.6,26.5 c4.3,2.3,8.6,4.6,12.8,7.1c10.7,6.4,20.8,14,29.9,22.5c9.6,8.9,18.3,18.9,25.8,29.6c6,8.6,11.2,17.7,15.6,27.2 c0.7,1.5,1.3,2.9,2,4.4c0.6,1.4,1.2,2.9,1.7,4.3c7.2,18.9,10,40.1,0.8,57.8c-9.1,17.6-29,28-48.8,29.5c-11.4,0.7-22.9-0.8-33.8-4.5 c-8-2.6-15.7-5.9-23.1-9.9c-34.3-18.4-61.4-47.5-86.2-77.5c-24.8-30-48.1-61.5-77.5-87c-29.4-25.4-66.2-44.7-105.1-44.4 c-38.9,0.3-79,24-90,61.3c-16.1-27.7-27-59.4-25.5-91.4S291.7,190,318.6,172.7z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 469.5,
    cy: 272,
    r: 4.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 308.5,
    cy: 275.8,
    r: 6.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 785.9,
    cy: 221.5,
    r: 2.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 736.5,
    cy: 90.4,
    r: 2.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M673.7,331.1c0.7-2,1.6-3.9,2.8-5.7c4.3,2.3,8.6,4.6,12.8,7.1c10.7,6.4,20.8,14,29.9,22.5 c-8.5,11.6-24.8,14.1-36.4,5.5C673.7,353.8,670,341.9,673.7,331.1L673.7,331.1z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 362.5,
    cy: 249.2,
    r: 2.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 668.2,
    cy: 64.5,
    r: 2.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 645.8,
    cy: 20.1,
    r: 2.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 822.5,
    cy: 185.8,
    r: 2.5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 691.4,
    cy: 189.4,
    r: 2.5
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 621.8,
    cy: 427.4,
    r: 2.5
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 543.4,
    cy: 193.3,
    r: 2.5
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 539.9,
    cy: 146.1,
    r: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M696.8,406.6c-3.7-0.2-7.3-0.2-10.8,0c-21.4,0.7-35.6,6.9-39,16.8c-3.4,9.9,3.9,23.5,20.2,37.4 c1.6,1.4,3.3,2.7,5,4.1C672.2,442.9,681,421.8,696.8,406.6L696.8,406.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M676.7,438c4.1-11.9,11-22.7,20.1-31.4c1.2-1.1,2.4-2.3,3.7-3.3c12.6-10.6,28.1-17.1,44.5-18.6 c6,8.6,11.2,17.7,15.6,27.2c0.7,1.5,1.3,2.9,2,4.4c0.6,1.4,1.2,2.9,1.7,4.3c7.2,18.9,10,40.1,0.8,57.8c-9.1,17.6-29,28-48.8,29.5 c-11.4,0.7-22.9-0.8-33.8-4.5c-5.9-10.4-9.4-22.1-10.1-34.1c-0.1-1.5-0.1-3-0.2-4.5C672.2,455.7,673.7,446.6,676.7,438z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M643.7,422.2c4-11.6,19-18.3,42.2-19.2c4.6-0.2,9.8,1.8,14.6,0.2c23.4-7.4,44.7-2.6,62.1,13 c0.6,1.4,1.2,2.9,1.7,4.3c-0.2-0.1-0.5-0.2-0.7-0.2c-23.5-8.1-46.8-12.9-66.8-13.7c-3.7-0.1-8.1-2.3-10.8,0 c-21.2,18-35.6,10.5-39,16.8c-5.1,9.2,3.9,23.5,20.2,37.4c1.6,1.4,3.3,2.7,5,4.1c0,1.5,0.1,3,0.2,4.5c-2.6-1.9-5.1-3.9-7.5-5.9 C647.2,448.4,639.7,433.8,643.7,422.2z"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 731.6,
    cy: 501.5,
    r: 2.5
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 687.4,
    cy: 469.4,
    r: 2.5
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 721.2,
    cy: 454.4,
    r: 24.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M339.9,186.1c5.7,0.3,17.4,3.1,30.1,6.7c12.7,3.6,26.5,8.1,40.1,12.5c23.8,7.7,47.6,15.4,71.5,23.1 c3.3,1.1,6.6,2.1,9.9,3.2c1.3,1.6,2.5,3.3,3.7,5c-2.9-1-5.8-2-8.7-3c-12.4-4-23.1-6.7-35.1-10.3c-18.5-5.6-38-13-56.9-19.9 C375.5,196.5,353.8,189.1,339.9,186.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M763.4,137.3l53.6,88.9l-50.6-90.7c-0.2-1-1.2-1.6-2.2-1.4c-1,0.2-1.6,1.2-1.4,2.2 C762.9,136.6,763.1,137,763.4,137.3z"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 737.3,
    cy: 397.3,
    r: 2.5
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 299.5,
    cy: 375.5,
    r: 16
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M290.1,366.7c-6.1-1.7-9.7-8-8-14.1c0.2-0.6,0.4-1.3,0.7-1.9l-29-28.5l20.7-4.4l24.3,27.8 c5.5,3.1,7.5,10.1,4.4,15.7C300.6,365.9,295.2,368.2,290.1,366.7L290.1,366.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.5,144.8l16.2,10.6l18.9,4.4c0,0,15,107.2,22.4,113.6s1.2,7,3.2,15.9s6.6,27,6.6,27 c-44.9,27.8-85,31.2-119.2,4.6c-1.1-3.6,0.5-7.5,3.8-9.4c5.8-3.6-6.8-17.7-2-20.5s-3.6-23.9-3.6-23.9l1.5-45.3L95,215l5.7-44.6 l14.8-6.6l5.1-15L151.5,144.8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M158.5,148.5l26.6,8.9c0,0,29.5-3.1,30.7,40.8s-4.3,67.4-4.3,67.4s61.3,123.3-5.1,86.9L187,276l-20-120 L158.5,148.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M185.3,245.5l13.8-1.9c0,0,1.3,20.8,7.9,24s4.4,3.7,5.2,7s-5.9,12.6-0.6,14.9s51,60,51,60l27-25 c-1.9-5-10.8-0.9-11.3-6.3c-0.7-8.1-14.8-30.1-17.8-32.9s-1.8-7.8-3.4-14.5s-0.5-0.5-3.1-11.6c-2.6-11.1-37.8-67.9-39-78.2 s-15.6-16.3-15.6-16.3l-11.1,2.6L185.3,245.5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M63.6,632.8l50,13.1l0.2-0.6c2.8-10.8-3.6-21.8-14.4-24.6l0,0l-7.3-9.3l-18.9,2.5l-4.4-1.1L63.6,632.8z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M151.4,645.7l51.7,0v-0.7c0-11.1-9-20.1-20.1-20.1h0l-9.4-7.2l-17.6,7.2l-4.5,0L151.4,645.7z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M119.5,151.5l-24.9,15.9l-12.1,10.1l16,102c0,0-24.3,92.7,14,87s36.2-89,36.2-89L119.5,151.5z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152.9,296.4c-5.4,3.2-12.5,1.4-15.7-4c-0.3-0.6-0.6-1.2-0.9-1.8l-40.6,1l11.2-17.9l36.9,1.8 c6.1-1.8,12.5,1.6,14.3,7.7C159.7,288.3,157.5,293.7,152.9,296.4z"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 132.6,
    cy: 105.6,
    r: 32.1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M96.2,84.5c3.6-5.6,10.4-9.3,16.9-8.3c1.8-12.6,13.6-21.4,26.2-19.5c4.7,0.7,9.1,2.8,12.5,6.1 c2.1-1.4,4.7-1.7,7-0.7c2.3,1,4.2,2.6,5.7,4.6c7.7,9.6,9.5,22.6,4.7,33.9c0.8-2.9-2.1-5.7-5.1-6.3c-3-0.7-6,0-9-0.5 c-3.8-0.5-7.3-2.8-11.1-3.3c-3.2-0.4-6.5,0.4-9.6,1.2c-3.1,0.8-6.4,1.7-9.6,1.3c-3.2-0.4-7.4,11.9-7.3,20.5c0,1.6-0.3,3.7-1.9,4.1 c-2,0.4-3.1-2.3-5-3c-1.8-0.5-3.7,0.5-4.3,2.3c-0.5,1.8-0.1,3.6,1.1,5.1c1.2,1.4,2.5,2.6,4,3.5l-0.8,0.6c-1.3,1.7-3.9,1.8-5.8,0.7 c-1.8-1.2-3.2-2.8-4.2-4.7c-3.4-5.7-6.4-11.8-7.6-18.3S92.6,90.1,96.2,84.5z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M107.5,180.5l-14.4-12.4c0,0-16.9,5.3-19.7,16.3c-22.5,28.8-34.6,62.3-37.9,100.1c29.4,11.1,65.3,15,104,16 l-8-30l-55-10L107.5,180.5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M332.5,648h-67c-6.4,0-11.5-5.2-11.5-11.5v-235c0-6.4,5.2-11.5,11.5-11.5h67c6.4,0,11.5,5.2,11.5,11.5v235 C344,642.9,338.9,648,332.5,648z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M316.7,396h-34.3c-2.4,0-4.3-1.9-4.3-4.3v-12.3c0-2.4,1.9-4.3,4.3-4.3h34.3c2.4,0,4.3,1.9,4.3,4.3v12.3 C321,394.1,319.1,396,316.7,396z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M414.9,648.4L1.2,648.7c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2l413.8-0.3c0.7,0,1.2,0.5,1.2,1.2 C416.1,647.8,415.6,648.4,414.9,648.4z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 297.4,
    className: "st1",
    width: 54,
    height: 54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunching);
export default __webpack_public_path__ + "static/media/launching.37f6b5388e7883d4def0e3b7b7673761.svg";
export { ForwardRef as ReactComponent };